function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M16.377 16.065c-.824 0-1.599-.32-2.181-.903l-3.15-3.15c-.221-.222-.607-.221-.828 0l-3.161 3.161c-.583.583-1.358.903-2.181.903h-.621l3.989 3.99c1.246 1.245 3.266 1.245 4.512 0l4-4.001h-.379zM4.876 4.924c.824 0 1.598.32 2.181.903l3.161 3.162c.228.227.6.228.828 0l3.15-3.15c.582-.583 1.357-.904 2.181-.904h.38l-4.001-4C11.51-.312 9.49-.312 8.244.934L4.255 4.923h.62z",
  transform: "translate(-1 -1) translate(0 1) translate(2 1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.066 8.244l-2.418-2.417c-.053.02-.11.034-.172.034h-1.099c-.568 0-1.124.23-1.526.632l-3.15 3.15c-.294.295-.682.443-1.069.443-.387 0-.774-.148-1.069-.442L6.402 6.482C6 6.08 5.444 5.85 4.876 5.85H3.524c-.058 0-.111-.014-.162-.033L.934 8.244C-.31 9.49-.31 11.51.934 12.756l2.428 2.427c.05-.02.104-.033.162-.033h1.352c.568 0 1.124-.23 1.526-.632l3.161-3.161c.571-.571 1.567-.571 2.138 0l3.15 3.15c.402.401.958.632 1.526.632h1.1c.06 0 .118.013.171.034l2.418-2.417c1.245-1.246 1.245-3.266 0-4.512z",
  transform: "translate(-1 -1) translate(0 1) translate(2 1)"
})));

var SvgPix = function SvgPix(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: props.color
  }, _ref2)));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPix, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pix.74537cb5.svg";
export { ForwardRef as ReactComponent };